import { render, staticRenderFns } from "./AlternateContact.vue?vue&type=template&id=3efc299b"
import script from "./AlternateContact.vue?vue&type=script&lang=js"
export * from "./AlternateContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports